import React, { useEffect, useState, useRef } from 'react';
import Chart from 'chart.js/auto';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const BuildABarGame = () => {
  const categories = {
    Candy: ['Red Candy', 'Blue Candy', 'Green Candy', 'Yellow Candy', 'Purple Candy'],
    Animals: ['Dogs', 'Cats', 'Bears', 'Birds', 'Rabbits'],
  };
  const allItems = [...categories.Candy, ...categories.Animals];

  const questions = [
    { text: 'Collect 5 Red Candy and 3 Dogs.', answer: { 'Red Candy': 5, 'Dogs': 3 } },
    { text: 'Get 4 Blue Candy, 2 Bears, and 1 Rabbit.', answer: { 'Blue Candy': 4, 'Bears': 2, 'Rabbits': 1 } },
    { text: 'Gather 6 Yellow Candy and 4 Cats.', answer: { 'Yellow Candy': 6, 'Cats': 4 } },
    { text: 'Collect 3 Green Candy, 5 Birds, and 2 Purple Candy.', answer: { 'Green Candy': 3, 'Birds': 5, 'Purple Candy': 2 } },
    { text: 'Get 7 Purple Candy and 3 Rabbits.', answer: { 'Purple Candy': 7, 'Rabbits': 3 } }
  ];

  const sounds = {
    slider: new Audio('https://actions.google.com/sounds/v1/cartoon/slide_whistle_to_drum_roll.ogg'),
    correct: new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg'),
    wrong: new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'),
    reset: new Audio('https://actions.google.com/sounds/v1/cartoon/slide_whistle_down.ogg'),
    next: new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'),
  };

  const [dataValues, setDataValues] = useState(Array(allItems.length).fill(0));
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [chartInstance, setChartInstance] = useState(null);
  const [nextEnabled, setNextEnabled] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
    const chart = new Chart(canvasRef.current, {
      type: 'bar',
      data: {
        labels: allItems,
        datasets: [{
          data: dataValues,
          backgroundColor: [
            '#e53935', '#1e88e5', '#43a047', '#fdd835', '#8e24aa',
            '#a52a2a', '#808080', '#8b4513', '#6a5acd', '#32cd32'
          ],
          borderRadius: 8,
          borderSkipped: false,
        }]
      },
      options: {
        responsive: true,
        animation: { duration: 400, easing: 'easeOutBounce' },
        scales: {
          y: {
            beginAtZero: true,
            max: 10,
            ticks: { stepSize: 1 },
            title: { display: true, text: 'Count' }
          }
        },
        plugins: { legend: { display: false } }
      }
    });
    setChartInstance(chart);
    nextQuestion();
    return () => chart.destroy();
  }, []);

  const playSound = (name) => {
    try {
      sounds[name].currentTime = 0;
      sounds[name].play();
    } catch {}
  };

  const updateSlider = (index, value) => {
    const newData = [...dataValues];
    newData[index] = Number(value);
    setDataValues(newData);
    if (chartInstance) {
      chartInstance.data.datasets[0].data = newData;
      chartInstance.update();
    }
    setFeedback('');
    setNextEnabled(false);
    playSound('slider');
  };

  const checkAnswer = () => {
    if (!currentQuestion) return;
    const { answer } = currentQuestion;
    let correct = true;
    for (const [item, count] of Object.entries(answer)) {
      const i = allItems.indexOf(item);
      if (dataValues[i] !== count) {
        correct = false;
        break;
      }
    }
    if (correct) {
      for (let i = 0; i < dataValues.length; i++) {
        if (!(allItems[i] in answer) && dataValues[i] !== 0) {
          correct = false;
          break;
        }
      }
    }

    if (correct) {
      setScore(score + 1);
      setFeedback('🎉 Correct! Great job!');
      setNextEnabled(true);
      playSound('correct');
         const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback('❌ Not quite right, try again!');
      playSound('wrong');
    }
  };

  const resetGame = (clearFeedback = true) => {
    const newValues = Array(allItems.length).fill(0);
    setDataValues(newValues);
    if (chartInstance) {
      chartInstance.data.datasets[0].data = newValues;
      chartInstance.update();
    }
    if (clearFeedback) setFeedback('');
    playSound('reset');
    setNextEnabled(false);
  };

  const nextQuestion = () => {
    resetGame(false);
    const randomQ = questions[Math.floor(Math.random() * questions.length)];
    setCurrentQuestion(randomQ);
    setFeedback('');
    playSound('next');
  };

  const styles = {
    container: { fontFamily: 'Comic Sans MS', background: '#fff0f5', padding: 20, textAlign: 'center', color: '#333', userSelect: 'none' },
    h1: { fontSize: '2.2rem', color: '#d81e5b', marginBottom: 10 },
    avatar: { fontSize: 50, animation: 'bounce 2s infinite', marginBottom: 15 },
    scenario: { fontSize: '1.25rem', background: '#fde7f1', margin: '15px auto', maxWidth: 600, padding: 15, borderRadius: 12, border: '2px solid #d81e5b' },
    inputs: { maxWidth: 520, margin: '20px auto 30px', textAlign: 'left' },
    inputGroup: { marginBottom: 18 },
    label: { fontWeight: 'bold', marginBottom: 5, display: 'block' },
    slider: { width: '100%', cursor: 'pointer' },
    valueDisplay: { float: 'right', fontWeight: 'bold', color: '#d81e5b' },
    button: { backgroundColor: '#d81e5b', color: 'white', border: 'none', borderRadius: 10, padding: '12px 25px', fontSize: 18, margin: '10px 10px 0 10px', cursor: 'pointer' },
    chartContainer: { maxWidth: 700, margin: '0 auto' },
    feedback: { fontSize: '1.2rem', marginTop: 15, fontWeight: 'bold', minHeight: 30 },
    score: { fontSize: '1.3rem', fontWeight: 'bold', color: '#d81e5b', marginTop: 10 }
  };

  return (
    <div style={styles.container}>
      <style>{`@keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-20px); }}`}</style>
      <h1 style={styles.h1}>🍭 Build-a-Bar Game with Quiz & Points</h1>
      <div style={styles.avatar}>🍬🍫🍭🐶🐱🐻</div>
      <div style={styles.scenario} aria-live="polite">{currentQuestion?.text || 'Loading question...'}</div>

      <div style={styles.inputs} aria-label="Select counts for items">
        {allItems.map((item, i) => (
          <div key={i} style={styles.inputGroup}>
            <label htmlFor={`slider-${i}`} style={styles.label}>
              {item}
              <span style={styles.valueDisplay}>{dataValues[i]}</span>
            </label>
            <input
              id={`slider-${i}`}
              type="range"
              min="0"
              max="10"
              value={dataValues[i]}
              onChange={e => updateSlider(i, e.target.value)}
              style={styles.slider}
              aria-label={`${item} count`}
              aria-valuemin="0"
              aria-valuemax="10"
              aria-valuenow={dataValues[i]}
            />
          </div>
        ))}
      </div>

      <div>
        <button style={styles.button} onClick={checkAnswer} disabled={nextEnabled}>Check Answer</button>
        <button style={styles.button} onClick={nextQuestion} disabled={!nextEnabled}>Next Question</button>
        <button style={styles.button} onClick={() => resetGame(true)}>Reset</button>
      </div>

      <div style={styles.feedback} aria-live="polite">{feedback}</div>
      <div style={styles.score}>Score: {score}</div>

      <div style={styles.chartContainer}>
        <canvas ref={canvasRef} aria-label="Items count bar chart" />
      </div>
    </div>
  );
};

export default BuildABarGame;
